import { zonedTimeToUtc } from '@fareye/utils'
import { severityColors } from '@fareye/configs'
export function getColorOnSeverity(severity: string) {
  return (severityColors as any)[severity] ?? 'rgb(105, 192, 255)'
}
const TIMEZONE_KEY = '@IDV:transportation-timezone'
export const zonedToUTC: any = (time: any) => {
  const pickTimezoneFromStorage = localStorage.getItem(TIMEZONE_KEY)
  if (pickTimezoneFromStorage) {
    let { value = '' } = JSON.parse(pickTimezoneFromStorage)
    if (value) {
      return zonedTimeToUtc(time, value)
    } else {
      return time
    }
  } else {
    return time
  }
}

export const zonedToUTCAdd1Day: any = (time: any) => {
  let date = zonedToUTC(time)
  // add a day
  date.setDate(date.getDate() + 1)
  return date
}
